module.exports = __webpack_public_path__ + "static/img/mascot-betask-1.4569a29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mascot-betask-1.png
// module id = b/FN
// module chunks = 3